export const isChromeOrEdge = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }

  const { userAgent } = navigator

  if (/YaBrowser|YaSearchBrowser|OPR|Opera|SamsungBrowser/i.test(userAgent)) {
    return false
  }

  return /Edg\/|EdgiOS\/|Edge\/|Chrome\/|CriOS\//.test(userAgent)
}
